var map = {
	"./add-icon.png": 84280,
	"./agriculture.png": 96462,
	"./arrow-down.png": 8165,
	"./cul.png": 77921,
	"./eco.png": 46538,
	"./energy.png": 31601,
	"./env.png": 2624,
	"./health.png": 55255,
	"./law.png": 95561,
	"./local.png": 70756,
	"./logo-txt.png": 68415,
	"./logo.png": 76928,
	"./milt.png": 61915,
	"./old.png": 45074,
	"./other.png": 9247,
	"./phone.png": 27321,
	"./pol.png": 21296,
	"./social.png": 21140,
	"./statics.png": 6644,
	"./sub-icon.png": 87229,
	"./tech.png": 45061,
	"./time-icon.png": 96074,
	"./tran.png": 70746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85994;